export default __webpack_public_path__ + "files/bb70781ccd4fbf5f99bf8a8060f82662.gif";